import { connect } from 'react-redux';
import Header from './header';
import withPGTranslation from '../../config/withPGTranslation';
import { displayRegister } from '../../actions/auth';

const mapStateProps = ({
  user: { user }, application
}) => ({
  ...user,
  badgeCount: application.badgeCount,
  application,
  userBonusInfos: user && user.bonusInfos,
  userXfmProgram: user && user.xfmProgram,
  userId: user && user.id,
  bonusInfos: application?.anonymousUser?.bonusInfos ?? application?.dynamicConfig?.bonusInfos,
  showAddFundsMenuItem: user?.settings?.showAddFundsMenuItem ?? false
});

export default connect(mapStateProps, {
  displayRegister
})(withPGTranslation(Header));
